export const IconLockFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M8.964 7.625V9.5h6.072V7.625C15.036 5.898 13.677 4.5 12 4.5S8.964 5.898 8.964 7.625M6.536 9.5V7.625C6.536 4.52 8.983 2 12 2s5.464 2.52 5.464 5.625V9.5h.607c1.34 0 2.429 1.121 2.429 2.5v7.5c0 1.379-1.09 2.5-2.429 2.5H5.93C4.589 22 3.5 20.879 3.5 19.5V12c0-1.379 1.09-2.5 2.429-2.5z" />
    </svg>
  );
};
